import { useLocation } from 'react-router-dom';
import React from 'react';
import { getOrgTermsContent } from '../../../../content/utils.js';
import ProfileTabs from '../../../organizations/ProfileTabs.jsx';
import PageHeader from '../../PageHeader.js';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import OrganizationTabs from '../../../organizations/OrganizationTabs.jsx';
import { getOrganizationPage } from '../../../../helpers/breadcrumbRouteHelpers.js';
import { SHOW_EMPLOYEES_BREADCRUMB_SEGMENT } from '../../../../constants/employeeProfile.js';
import {
  CustomSettingsLink,
  OrganizationEmployeesLink,
  OrganizationLink,
  OrganizationStakeholdersLink,
  OrganizationUsersLink,
  PermissionsLink,
  UserLink,
} from '../../../links/index.jsx';

const OrganizationHeader = ({
  organizationTabs,
  profileTabs,
  userId,
  currentUserId,
  userName,
  employeeName,
  employeeId,
  orgRole,
  permissions,
  canManageCustomSettings,
  profileSearch,
}) => {
  const location = useLocation();
  const orgPage = getOrganizationPage(location.pathname);
  const renderTabs = () => {
    if (organizationTabs) return <OrganizationTabs />;
    if (profileTabs)
      return (
        <ProfileTabs
          permissions={permissions || []}
          orgRole={orgRole}
          userId={userId}
          employeeId={employeeId}
          currentUserId={currentUserId}
          search={profileSearch}
        />
      );

    <OrganizationTabs />;

    return null;
  };
  return (
    <PageHeader
      flex
      flexJustify
      style={{ alignItems: 'baseline' }}
      navigation={renderTabs()}
    >
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        {orgPage === 'organization' && <span>Organization</span>}

        {orgPage === 'organization-edit' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'organization-edit' && (
          <span>Edit Organization Structure</span>
        )}

        {orgPage === 'users' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'users' && <span>Users</span>}

        {orgPage === 'users-new' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'users-new' && (
          <OrganizationUsersLink>Users</OrganizationUsersLink>
        )}
        {orgPage === 'users-new' && <span>Add User</span>}

        {orgPage === 'user-show' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'user-show' && (
          <OrganizationUsersLink>Users</OrganizationUsersLink>
        )}
        {orgPage === 'user-show' && <span>{userName}</span>}

        {orgPage === 'user-edit' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'user-edit' && (
          <OrganizationUsersLink>Users</OrganizationUsersLink>
        )}
        {orgPage === 'user-edit' && (
          <UserLink userId={userId}>{userName}</UserLink>
        )}
        {orgPage === 'user-edit' && <span>Edit User</span>}

        {orgPage === 'user-permissions' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'user-permissions' && (
          <OrganizationUsersLink>Users</OrganizationUsersLink>
        )}
        {orgPage === 'user-permissions' && (
          <UserLink userId={userId}>{userName}</UserLink>
        )}
        {orgPage === 'user-permissions' && <span>Permissions</span>}

        {orgPage === 'user-permissions-edit' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'user-permissions-edit' && (
          <OrganizationUsersLink>Users</OrganizationUsersLink>
        )}
        {orgPage === 'user-permissions-edit' && (
          <UserLink userId={userId}>{userName}</UserLink>
        )}
        {orgPage === 'user-permissions-edit' && (
          <PermissionsLink userId={userId}>Permissions</PermissionsLink>
        )}
        {orgPage === 'user-permissions-edit' && (
          <span>{location.pathname.includes('/new') ? 'New' : 'Edit'}</span>
        )}

        {orgPage === 'custom-settings' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'custom-settings' && <span>Custom Settings</span>}

        {orgPage === 'custom-settings-statuses-edit' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'custom-settings-statuses-edit' && (
          <CustomSettingsLink>Custom Settings</CustomSettingsLink>
        )}
        {orgPage === 'custom-settings-statuses-edit' && (
          <span>
            Edit {getOrgTermsContent('project')} And{' '}
            {getOrgTermsContent('portfolio')} Statuses
          </span>
        )}

        {orgPage === 'custom-settings-change-impact-types-edit' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'custom-settings-change-impact-types-edit' && (
          <CustomSettingsLink>Custom Settings</CustomSettingsLink>
        )}
        {orgPage === 'custom-settings-change-impact-types-edit' && (
          <span>Edit Change Impact Types</span>
        )}

        {orgPage === 'custom-settings-organization-settings-edit' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'custom-settings-organization-settings-edit' && (
          <CustomSettingsLink>Custom Settings</CustomSettingsLink>
        )}
        {orgPage === 'custom-settings-organization-settings-edit' && (
          <span>Edit Organization Settings</span>
        )}

        {orgPage === 'custom-settings-categories-edit' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'custom-settings-categories-edit' && (
          <CustomSettingsLink>Custom Settings</CustomSettingsLink>
        )}
        {orgPage === 'custom-settings-categories-edit' && (
          <span>Edit {getOrgTermsContent('initiative')} Categories</span>
        )}

        {orgPage === 'custom-settings-change-insights-new' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'custom-settings-change-insights-new' && (
          <CustomSettingsLink>Custom Settings</CustomSettingsLink>
        )}
        {orgPage === 'custom-settings-change-insights-new' && (
          <span>New Feedback Form</span>
        )}

        {orgPage === 'custom-settings-change-insights-edit' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'custom-settings-change-insights-edit' && (
          <CustomSettingsLink>Custom Settings</CustomSettingsLink>
        )}
        {orgPage === 'custom-settings-change-insights-edit' && (
          <span>Edit Feedback Form</span>
        )}

        {orgPage === 'custom-settings-change-insights-preview' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'custom-settings-change-insights-preview' && (
          <CustomSettingsLink>Custom Settings</CustomSettingsLink>
        )}
        {orgPage === 'custom-settings-change-insights-preview' && (
          <span>Feedback Form Preview</span>
        )}

        {orgPage === 'change-insights-preview' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'change-insights-preview' && canManageCustomSettings && (
          <CustomSettingsLink>Custom Settings</CustomSettingsLink>
        )}
        {orgPage === 'change-insights-preview' && <span>Feedback Form</span>}

        {orgPage === 'stakeholders' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'stakeholders' && <span>Organization Stakeholders</span>}

        {orgPage === 'stakeholders-edit' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'stakeholders-edit' && (
          <OrganizationStakeholdersLink>
            Organization Stakeholders
          </OrganizationStakeholdersLink>
        )}
        {orgPage === 'stakeholders-edit' && (
          <span>Edit Organization Stakeholders</span>
        )}

        {orgPage === 'employees' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'employees' && <span>Employees</span>}

        {orgPage === 'employees-edit' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'employees-edit' && (
          <OrganizationEmployeesLink>Employees</OrganizationEmployeesLink>
        )}
        {orgPage === 'employees-edit' && <span>Edit Employees</span>}

        {orgPage === 'employee-show' && (
          <OrganizationLink>Organization</OrganizationLink>
        )}
        {orgPage === 'employee-show' && SHOW_EMPLOYEES_BREADCRUMB_SEGMENT && (
          <OrganizationEmployeesLink>Employees</OrganizationEmployeesLink>
        )}
        {orgPage === 'employee-show' && <span>{employeeName}</span>}
      </BreadCrumbs>
    </PageHeader>
  );
};

export default OrganizationHeader;
